import { http } from '@frontend/fetch';

export const registerPhone = (sipProfileId: string) => {
  http.post<unknown>('/v1/sip/register', {
    workstation_slug: sipProfileId,
  });
};
